/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import { HintField, LabelField } from "components";
import React, { memo } from "react";
import "./style.scss";

const TextArea = memo(
  ({
    memberInfo,
    title,
    name,
    style,
    type,
    rules,
    error,
    formik,
    checkValidation = false,
    mandatory = false,
    ...rest
  }) => {
    const getInputClasses = () => {
      if (!checkValidation) {
        return "";
      }

      if (formik.touched[name] && formik.errors[name]) {
        return "is-invalid";
      }

      if (formik.touched[name] && !formik.errors[name]) {
        return "is-valid";
      }

      return "";
    };

    return (
      <div
        className={
          memberInfo
            ? "form-group fv-plugins-icon-container member-info-form"
            : "form-group fv-plugins-icon-container "
        }
      >
        <LabelField
          className={memberInfo ? "member-info-form-lable" : ""}
          htmlFor={name}
          title={title}
          mandatory={mandatory}
        />
        <textarea
          rows={6}
          style={style}
          id={name}
          className={
            memberInfo
              ? `member-info-form-input form-control form-control-solid h-auto py-5 px-6 ${getInputClasses()}`
              : `form-control form-control-solid h-auto py-5 px-6 ${getInputClasses()}`
          }
          {...rest}
          {...formik.getFieldProps(name)}
        />

        {formik.touched[name] && formik.errors[name] ? (
          <HintField error={formik.errors[name]} />
        ) : null}
      </div>
    );
  }
);
export default TextArea;
